import React, { useEffect, useState } from "react";
import back from "../../../assets/back.svg";
import { NavLink, useNavigate } from "react-router-dom";
import { AdminButton } from "../../../components/buttons/versionHistoryBtn";
import { useDispatch } from "react-redux";
import {
  fieldForceAdminDetail,
  fieldForceAdminOverride,
} from "../../../redux/actions/fieldForceAction";
import ErrorPopup from "../../../components/popups/ErrorPopup";
import LoadingSpinnerTable from "../../../components/utilites/loader";
import useReactRouterBreadcrumbs from "use-react-router-breadcrumbs";
import Switch from "react-switch";

const FieldForceAdminView = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [adminData, setAdminData] = useState("");
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");
  const [loding, setLoding] = useState(false);
  const [userData, setUserData] = useState(null);
  const [overrideSet, setOverrideSet] = useState(
    !adminData?.fieldForceDesignation?.is_override
  );

  console.log();

  const user_type = localStorage.getItem("userType");
  useEffect(() => {
    if (user_type === "super_user") {
      const permissionData = JSON.parse(localStorage.getItem("permissions"));
      const permissionValue = permissionData?.find(
        (item) => item?.module_name === "Field Force" && item
      );

      setUserData(permissionValue);
    }
  }, []);

  useEffect(() => {
    setLoding(true);
    dispatch(fieldForceAdminDetail(onSuccess, onError));
  }, []);

  const onSuccess = (data) => {
    setLoding(false);
    console.log(data);
    setAdminData(data?.data?.data);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const overrideFnc = () => {
    if (overrideSet == true) {
      setLoding(true);
      dispatch(fieldForceAdminOverride(onOverrideSuccess, onOverrideError));
    } else {
      setLoding(true);
      dispatch(fieldForceAdminOverride(onOverrideSuccess, onOverrideError));
    }
  };

  const onOverrideSuccess = (data) => {
    setLoding(false);
    setAdminData(data?.data?.data);
  };

  const onOverrideError = () => {
    // setShowErrorPopup(false);
  };

  const onError = (err) => {
    setLoding(false);
    console.log(err);
    setShowErrorPopup(true);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
  };
  const routes = [
    { path: "/", breadcrumb: "Admin" },
    {
      path: "/field-force/admin/view",
      breadcrumb: adminData?.code
        ? ` / field force / admin / ${adminData?.code} - view`
        : " / field force / admin / view",
    },
  ];
  const breadcrumbs = useReactRouterBreadcrumbs(routes, {
    disableDefaults: true,
  });

  return (
    <>
      <div className="products-page">
        <div className="products-main-div">
          <div className="mx-3">
            {breadcrumbs.map(({ match, breadcrumb }) => (
            <NavLink
              key={match.pathname}
              to={match.pathname}
              className="header-route-page fw_400 cursor_pointer"
            >
              <span className="fs_18">{breadcrumb}</span>
            </NavLink>
          ))} 
          </div>
         
          <div className="products-main-list my-2 py-1">
            <div className="search-container d-flex justify-content-end">
              <div className=" d-flex justify-content-between align-items-center m-1 mb-2">
                {(user_type == "super_user" && userData?.write) ||
                user_type == "vendor" ? (
                  <>
                    <div className="d-flex my-2 align-items-center color_747f9e fw_400 fs_14 mx-3">
                      <label>Override Approvals</label>
                      <Switch
                        checked={overrideSet}
                        onChange={() => {
                          if (overrideSet == true) {
                            setOverrideSet(false);
                          } else {
                            setOverrideSet(true);
                          }
                          overrideFnc();
                        }}
                        className="mx-3"
                        onColor="#d3d6eb"
                        offColor="#d3d6eb"
                        onHandleColor="#7065E4"
                        offHandleColor="#747F9E"
                        uncheckedIcon={false}
                        checkedIcon={false}
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                        height={20}
                        width={40}
                      />
                    </div>
                    <AdminButton
                      background="#7065E4"
                      color="white"
                      width="100px"
                      onClick={() => navigate(`/field-force/admin/edit`)}
                    >
                      <span className="m-2">
                        {adminData?.code ? "EDIT" : "ADD"}
                      </span>
                    </AdminButton>
                  </>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div style={{ position: "relative" }}>
              {loding == true ? (
                <div className="list-spinner-container">
                  <LoadingSpinnerTable />
                </div>
              ) : (
                <div className="  ps-4 ps-lg-4 ms-3 mt-4 col-lg-5 col-md-6 col-10 ">
                  <div className="my-2">
                    <label className="color_747f9e fs_14">User ID</label>
                    <p className="fs_14 color_262c3d">{adminData?.code}</p>
                  </div>
                  <div className="my-2">
                    <label className="color_747f9e fs_14">
                      Company Employee ID
                    </label>
                    <p className="fs_14 color_262c3d">
                      {adminData?.employee_id}
                    </p>
                  </div>
                  <div className="my-2">
                    <label className="color_747f9e fs_14">Employee Name</label>
                    <p className="fs_14 color_262c3d">{adminData?.name}</p>
                  </div>
                  <div className="my-2">
                    <label className="color_747f9e fs_14">Phone Number</label>
                    <p className="fs_14 color_262c3d">
                      +{adminData?.country_code}
                      <span className="ms-1">{adminData?.mobile}</span>
                    </p>
                  </div>
                  <div className="my-2">
                    <label className="color_747f9e fs_14">Email Address</label>
                    <p className="fs_14 color_262c3d">{adminData?.email}</p>
                  </div>
                  <div className="my-2">
                    <label className="color_747f9e fs_14">Designation</label>
                    <p className="fs_14 color_262c3d">
                      {adminData?.fieldForceDesignation?.name}
                    </p>
                  </div>
                  {/* <div className="my-4">
                  <label className=" Neutral_Color fs_14">Levels</label>
                  <p className="fs_14">
                    {adminData?.fieldForceDesignation?.approval_level == "L1" &&
                      "Level 1"}
                    {adminData?.fieldForceDesignation?.approval_level == "L2" &&
                      "Level 2"}
                    {adminData?.fieldForceDesignation?.approval_level == "L3" &&
                      "Level 3"}
                    {adminData?.fieldForceDesignation?.approval_level == "L4" &&
                      "Level 4"}
                    {adminData?.fieldForceDesignation?.approval_level == "L5" &&
                      "Level 5"}
                    {adminData?.fieldForceDesignation?.approval_level == "L6" &&
                      "Level 6"}
                    {adminData?.fieldForceDesignation?.approval_level == "L7" &&
                      "Level 7"}
                    {adminData?.fieldForceDesignation?.approval_level == "L8" &&
                      "Level 8"}
                    {adminData?.fieldForceDesignation?.approval_level == "L9" &&
                      "Level 9"}
                    {adminData?.fieldForceDesignation?.approval_level ==
                      "admin" && "Admin"}
                  </p>
                </div> */}
                </div>
              )}
            </div>
          </div>
        </div>
        <ErrorPopup
          show={showErrorPopup}
          title={showErrorMsg}
          handleClose={closeErrorPopup}
        />
      </div>
    </>
  );
};

export default FieldForceAdminView;
